export enum IncomingDataType {
  ALL_SHIFTS_AND_EOD_RECONS,
  SHIFT_PARTIAL_UPDATE,
  EOD_PARTIAL_UPDATE,
  SHIFT_CREATED,
  SHIFT_DELETED,
  SETUP_REQUIRED,
  CONFIG_UPDATED
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/initialiaze/models/incoming-data-type.ts